import { render, staticRenderFns } from "./ModalDestroyData.vue?vue&type=template&id=bb5dbe10&scoped=true&"
import script from "./ModalDestroyData.vue?vue&type=script&lang=js&"
export * from "./ModalDestroyData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5dbe10",
  null
  
)

export default component.exports